export enum CategoryType {
    Letter = 1,
    Fax = 2,
    Other = 3,
}